import styled from "styled-components";

export const CandidateCardLink = styled.a`
  text-decoration: underline;
  color: #333 !important;
  width: 225px;
  z-index: ${(props) => (props.isDragging ? "8" : "0")};
`;

export const CandidateCardContainer = styled.div`
  font-size: 16px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  height: 85px;
  width: 278px;
  margin: 10px auto;
  background: #fff;
  background: ${(props) => props.isDragging && "#79D9D9 !important"};
  border: ${(props) => props.isDragging && "1px solid #79D9D9 !important"};
  z-index: ${(props) => (props.isDragging ? "8 !important" : "0")};

  &.unread-true {
    border: 3px solid #79D9D9 !important;
    height: 85px;

    .kanban-card-wrapper {
      padding: 6px 10px 6px 10px;
    }

    .fa-cog {
      color: #79D9D9;
    }

    .open svg {
      color: #402680;
    }

    &:hover {
      border: 3px solid #79D9D9;
    }
  }

  &.favourited-true {
    border: 3px solid #4d81f5 !important;
    height: 85px;

    .kanban-card-wrapper {
      padding: 6px 10px 6px 10px;
    }

    .fa-cog,
    .fa-exclamation-triangle {
      color: #4d81f5;
    }

    &:hover {
      border: 3px solid #4d81f5;
    }
  }

  &.accepted {
    border: 3px solid #27ae60;
    height: 85px;

    .kanban-card-wrapper {
      padding: 6px 12px 8px 12px;
    }

    &:hover {
      border: 3px solid #27ae60;
    }

    .kanban-candidate-link {
      right: 18px;
    }
  }

  &.new-update {
    border: 3px solid #f2994a;
    height: 85px;

    .kanban-card-wrapper {
      padding: 6px 12px 8px 12px;
    }

    .kanban-candidate-link {
      right: 18px;
    }

    &:hover {
      border: 3px solid #f2994a;
    }
  }

  &.no-update {
    &.unread-true .kanban-candidate-link {
      right: 17px;
    }

    .kanban-candidate-link {
      right: 16px;
    }
  }

  &.successful {
    border: 3px solid #27ae60;
    height: 85px;
    background: #27ae60;

    .kanban-card-wrapper {
      padding: 6px 12px 8px 12px;
    }

    .kanban-candidate-link {
      right: 18px;
      color: #fff !important;
    }

    .card-title,
    .card-content {
      color: #fff;
    }

    &:hover {
      border: 3px solid #27ae60;
      height: 85px;
      background: #27ae60;
    }
  }

  &.offered {
    border: 3px solid #f2994a;
    height: 85px;
    background: #f2994a;

    .kanban-card-wrapper {
      padding: 6px 12px 8px 12px;
    }

    .kanban-candidate-link {
      right: 18px;
      color: #fff !important;
    }

    .card-title,
    .card-content {
      color: #fff;
    }

    &:hover {
      border: 3px solid #f2994a;
      height: 85px;
      background: #f2994a;
    }
  }

  &.unsuccessful {
    background: #f4f4f4;
    border: 1px solid #d3d3d3 !important;

    .kanban-card-wrapper {
      padding: 6px 12px 8px 12px;
    }

    .kanban-candidate-link {
      right: 18px;
      color: #949494 !important;
    }

    .card-title,
    .card-content {
      color: #949494;
    }

    svg {
      display: none;
    }

    &:hover {
      background: #f4f4f4;
      border: 1px solid #dadada;
    }
  }

  &:hover {
    cursor: pointer;
    background: #f4f4f4;
    border: 1px solid #d3d3d3;

    .fa-times {
      color: transparent;
    }

    .fa-search {
      color: #525252;
    }
  }
`;

export const CandidateCardWrapper = styled.div`
  padding: 8px 12px;
  position: relative;
`;

export const CandidateCardTitle = styled.div`
  font-weight: bold;
  font-family: Komet;
  color: #333;
  width: 225px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.isDragging && "#fff !important"};
`;

export const CandidateCardContent = styled.div`
  line-height: 1.6em;
  font-size: 0.75em;
  font-family: Komet;
  letter-spacing: 0.5px;
  margin-top: 5px;
  color: #333;
`;

export const CandidateCardContentAbout = styled.div`
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.isDragging && "#fff"};
`;

export const CandidateCardContentDate = styled.div`
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.isDragging && "#fff"};
`;

export const CandidateStatusBadge = styled.div`
  width: 20px;
  position: relative;
  right: -3px;
  text-align: center;
  font-size: 1.7em;
  bottom: 20px;
  float: right;

  svg {
    font-size: 0.9em;
    color: ${(props) => props.isDragging && "#fff !important"};
  }

  .fa-arrow-circle-right {
    color: #f2994a;
  }

  .fa-question {
    color: #fff;
  }

  .fa-check {
    color: #fff;
  }

  .fa-check-circle {
    color: #27ae60;
  }

  .fa-times {
    color: transparent;
  }

  .fa-exclamation-triangle {
    display: block;
    color: #79D9D9;
    position: relative;
    right: 2px;
  }
`;

export const MakeOfferButton = styled.div`
  position: absolute;
  right: 6px;
  width: 30px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: #525252;
    font-size: 0.95em;
  }
`;
